import { render, staticRenderFns } from "./ReportHCO.vue?vue&type=template&id=518a2846&"
import script from "./ReportHCO.vue?vue&type=script&lang=ts&"
export * from "./ReportHCO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports